import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import LaptopImg from "../../../../assets/image/web-devloper.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import WhyChooseImg from "../../../../assets/image/analytics.gif";
import KeyBnifitsImg from "../../../../assets/image/file (2).png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import MobileHeroImg from "../../../../assets/image/mobile-hero-img.png";
import howItWorsImg from "../../../../assets/image/howItWork.png";
import EcomImage from '../../../../assets/image/ecommerce-Website.png'
import Ecommerce from '../../../../assets/image/ecommerce.png'
import onlineDelivery from '../../../../assets/image/online-delivey.png'
import "./MobileAppDev.css";
import Footer from "../../Footer";

const EcomMobileAppDev = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "iPhone App Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Android App Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Flutter App Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "React Native Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Swift App Development",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Ionic App Development",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];


  return (
    <>
      <Header />
      <section style={{ paddingTop: "30px" }}>
      <Container>
      <Grid container spacing={4} alignItems="center">
        {/* Left Section */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="subtitle1"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'bold',
              color: '#3a506b',
            }}
          >
            E-Commerce Services
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'bold',
              color: '#3a506b',
              marginTop: 2,
            }}
          >
            E-Commerce Mobile App Development
          </Typography>
          <br />
          <img
            src={EcomImage}
            alt="Zoodonix e-commerce"
            style={{
              maxWidth: '100%',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Grid>

        {/* Right Section */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="subtitle1"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'bold',
              color: '#5747e4',
            }}
          >
            Why Invest in E-Commerce App
          </Typography>
          <Typography
            variant="h6"
            sx={{ marginTop: 2, fontSize: '20px', fontWeight: 'bold' }}
          >
            E-Commerce Mobile App For Your Business
          </Typography>
          <Typography
            variant="body1"
            sx={{ marginTop: 2, fontSize: '18px', lineHeight: 1.6 }}
          >
            Our highly professional eCommerce app developers can develop an
            eCommerce app in your desired niche. We can build custom eCommerce
            applications that match your business on Android and iOS platforms
            & help clients in the entire eCommerce app development cycle.
          </Typography>
          <Button
            variant="contained"
            sx={{
              marginTop: 3,
              padding: '15px 25px',
              background: 'linear-gradient(96deg,#6254e7 0%,#9289f1 100%)',
              color: 'white',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              borderRadius: '50px',
              '&:hover': {
                background: 'linear-gradient(96deg,#5747e4 0%,#7268e8 100%)',
              },
            }}
          >
            Hire Ecommerce Developers
          </Button>
        </Grid>
      </Grid>
    </Container>
      </section>

      <section>
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textTransform: "uppercase",
              fontSize: "17px",
            }}
          >
            <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
          </div>
          <div className="slider-container">
            <Slider {...settings}>
              <div>
                <img width={70} src={SliderImg} alt="Client 1" />
              </div>
              <div>
                <img width={70} src={SliderImg2} alt="Client 2" />
              </div>
              <div>
                <img width={70} src={SliderImg3} alt="Client 3" />
              </div>
              <div>
                <img width={70} src={SliderImg4} alt="Client 4" />
              </div>
              <div>
                <img width={70} src={SliderImg5} alt="Client 5" />
              </div>
              <div>
                <img width={70} src={SliderImg6} alt="Client 6" />
              </div>
              <div>
                <img width={70} src={SliderImg7} alt="Client 6" />
              </div>
            </Slider>
          </div>
        </Container>
      </section>

      {/* video section  */}


      {/* video section  */}

      <section>
        <Container>
          <p className="text-uppercase text-bold" style={{ color: '#5747e4' }}>Why us for E-Commerce App</p>
          <p className="ts-18">E-business refers to conducting business on-line over the internet. This includes, buying and selling products, B2B, business-to-business (B2B) transactions, inter-company communications, information repositories etc. Any type of business can have its analogue on the internet and benefit from e-commerce. This is an exceptionally cost effective way of promoting your business, generating extra profits and delivering better services to your customers.<br />As a <a href="https://zoodonix.com">leading E-Commerce Mobile App Development company from Guwahati, Assam</a>, OZOSOFT Ecommerce Solutions brings years of experience in the field of ecommerce. Our team of highly trained and experience developers have designed and maintained many ecommerce websites. We can develop and maintain your ecommerce business as per your needs. We have been designing, developing and maintaining ecommerce websites since the staring of the ecommerce era.<br />Now more than ever, e-commerce is becoming a way of life. Every day millions of people log onto the web to conduct business, purchase products and hire services. Many merchants have already established their websites with the capability of direct online sales to accommodate their growing marketplace.</p>
          <p className="ts-18">We use standard open source software like Magento, Opencart, Woo Commerce for small and medium size business and for bigger organization some enterprise version of Magento, Shopify, BigCommerce or other eCommerce CMS to develop professional ecommerce website. We provide customized administrative area for your particular requirements, including product and inventory management, order processing, shipping and handling and payment gateway integration. We also offer Content Management System (CMS) websites with payment gateway integration.<br />E-business is more than just having an online store. It allows your company to create a genuine, one to one relationship with every customer or potential customer. By analyzing the data generated, you can create individual web pages automatically, send e-mail notification of sales and special promotions, test promotions and quickly improve the effectiveness of marketing programs.<br />The E-commerce solutions include professional shopping cart software, custom application development, payment gateway integration and marketing through search engine optimization, social media promotion.</p>
        </Container>
      </section>


      <section>
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6}>
              <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
                Trusted Web App Development Company
              </div>
              <Typography
                variant="h4"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#3a506b" }}
              >
                E-Commerce Mobile App Development Company in Guwahati
              </Typography>
              <p className="ts-18"> A study shows 9 out of 10 people feel more comfortable with using an app rather than browsing a website to buy things online. Indeed, it is a plus point for selling your stocks quickly. If your e-commerce site reaches to the users as a well-functioned mobile application, the chances of the product sales will increase rapidly. Dot Com Infoway, a top-notch eCommerce app development company have brought every possible functionalized and customized e-commerce mobile apps that make the purchases more accessible than ever. Catchy design, powerful control panel and smooth operating are our main mottos.</p>
              <p className="ts-18">
                We frame up your dream with our day-and-night dedications by making a fast and sophisticated e-commerce app which helps you reach your products to the customers very first.
              </p>
              <div>


              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={Ecommerce} />
            </Grid>
          </Grid>
          {/* <Grid container spacing={0}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} md={6}>
            <p style={{ textTransform: "uppercase", textAlign: "center" }}>
              Web development services
            </p>
          </Grid>
          <p style={{ fontSize: "20px" }}>
            Reseller Bano, one of the{" "}
            <a href="#">
              Top Web Design Company in Guwahati, Assam
            </a>
            , India Our customers are companies of all sizes ranging from
            start-ups to large enterprises who realize that they need a
            professional internet solution to set up revenue streams, build
            communication channels or streamline business operations. Our core
            competency is to promote your business online, to create online
            business opportunities and leads, and to empower your business. We
            are one of the best and Supportive website Design and Developers
            in the Guwahati, Assam, If you are looking for most affordable,
            creative, Reliable Professional website.
          </p>
        </Grid> */}

        </Container>

      </section>

      <section style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}>
        <Container>
          <div style={{ textAlign: "center" }}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Best for you
            </div>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              Core Features Of Our E-Commerce Mobile Application
            </Typography>
            <p style={{ fontSize: "20px" }}>
              Our ingenious eCommerce mobile app development team has brought you well-versed e-commerce apps. Every day, with every new project, they are endeavoring their year’s knowledge and skills to create updated apps so that the customers get the optimal experience of an e-commerce multiverse app of the following core features-
            </p>
          </div>
          <Grid container spacing={12}>
            {ourTeamGridData.map((item, index) => (
              <Grid item xs={12} md={6} key={item.id}>
                <div style={{ display: "flex", padding: "0px" }}>
                  <img
                    src={item.imgSrc}
                    width={50}
                    height={50}
                    alt="Placeholder 1"
                    style={{ marginRight: "10px" }}
                  />
                  <div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: `${item.color}`,
                      }}
                    >
                      {"0" + item.id}
                      <br />
                      {item.title}
                    </div>
                    <p
                      className="our-team-card-description"
                      style={{
                        fontSize: "18px",
                        color: "#8d99ae",
                        marginTop: "0",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>





      <section style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}>
        <Container>
          <div
            style={{
              textAlign: "center",
              backgroundImage:
                "linear-gradient(90deg, #56ab2f 0%, #a8e063 100%)",
              padding: "20px",
              color: "#fff",
              borderRadius: "20px",
              boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
            }}
          >
            <p className="text-uppercase text-bold">Welcome</p>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#fff" }}
              className="let-discuss-header"
            >
              Let's Discuss Your Project
            </Typography>
            <p className="let-discuss-para" style={{ fontSize: "18px" }}>
              We accept Mobile Application Development projects including Mobile
              App UI/UX Design from all major towns and cities of Assam
              including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
              Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
              Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
              to multiple cities of Northeast including Itanagar, Arunachal
              Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
              Agartala, Tripura, Kohima, Nagaland
            </p>
            <Button
              style={{
                padding: "15px 25px 15px 25px",
                background: "#fff",
                color: "black",
                borderRadius: "40px",
              }}
              variant="contained"
              color="#7209b7"
              className="text-uppercase"
            >
              Talk our experts
            </Button>
          </div>
        </Container>
      </section>




      <section>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <p className="text-uppercase text-bold">Analysis</p>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#3a506b" }}
                className="let-discuss-header"
              >
                Key Benefits Of Having An E-Commerce Mobile App
              </Typography>
              <p className="ts-18">
                Start your online product selling business by an impelling e-commerce app where you can sell different products of diverse categories and types.
              </p>
              <div>
                <ul style={{ textAlign: 'center', padding: '20px' , fontSize:'20px' }}>
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />Builds Creditability
                  </li>
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />Wider Audience Reach
                  </li>
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />Promote Your Business
                  </li>
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />Keep Track of Your Business
                  </li>
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />Improve Customer Service
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={onlineDelivery} alt="Reseller Bano Key Benefits" />
            </Grid>
          </Grid>

          <p className="text-uppercase text-bold"  style={{color:'#5747e4'}}>We Are</p>
          <p className="ts-18">Until now it cost a small fortune to design and set up an e-commerce solution on the Internet. To create a transaction based Web site either meant considerable software development with long costly development cycles or purchasing E-Commerce Mobile App Development packages that only did part of the job leaving you with no brand recognition and expensive consulting costs. We at Ozosoft will help you create visually exciting, powerfully interactive catalogues on the Internet at an affordable price. To minimize the cost and increase the scalability of the eCommerce website we transfered most of our clients to Google Cloud or Amazon AWS or Microsoft Azure Platform. Now we are one of the very few companies which completely moved to Cloud from traditional server setup which results in 0% downtime on websites and instantly scalable on demand. We develop secure back-office pages which allow you to collect, organize, manage and publish catalogues with total customization. Whether you are an established industry heavyweight or a young fledgling brand, you cannot ignore the value of positioning yourself on marketplaces to sell your product. In practice, 50-60% of your sales revenue might come from marketplaces, and the remaining from a combination of your own eCommerce website and other sources like offline stores.</p>
          <img src={FooterSvg} />

        </Container>
      </section>

<Footer/>


    </>
  )
}

export default EcomMobileAppDev
